import React, { Dispatch, SetStateAction } from "react";

import classNames from "classnames";

import spinnySpinner from "src/images/spinner-small.gif";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { SOCIAL_METRICS_FORM_TYPE } from "src/app/modals/ManageFieldModal/types";
import { FormHandler } from "../AccessLinkPageForm/components/FormHandler/FormHandler";
import { AccessLinkPageBlock } from "../AccessLinkPageBlock/AccessLinkPageBlock";
import { AccessLinkPageForm } from "../AccessLinkPageForm/AccessLinkPageForm";
import { AccessLinkPageHeaderContent } from "../AccessLinkPageHeaderContent/AccessLinkPageHeaderContent";

export type PageHandler = "success" | "expired" | undefined;

interface AccessLinkPageContentProps {
  pageHandler: PageHandler;
  setPageHandler: Dispatch<SetStateAction<PageHandler>>;
  response: any;
  anyFieldRequired: boolean;
  type: string;
}

export function AccessLinkPageContent({
  pageHandler,
  response,
  anyFieldRequired,
  setPageHandler,
  type,
}: AccessLinkPageContentProps) {
  return (
    <div
      className={classNames([
        "access-link-page",
        pageHandler && "access-link-page--single",
      ])}
    >
      {pageHandler ? (
        <FormHandler
          pageHandler={pageHandler}
          successMessage={response?.successMessage}
        />
      ) : response ? (
        <>
          {(response?.caption ||
            response?.description ||
            response?.wsAccessLinkLogo ||
            response?.wsAccessLinkCover) && (
            <AccessLinkPageBlock>
              <AccessLinkPageHeaderContent
                caption={response?.caption}
                description={response?.description}
                logo={response?.wsAccessLinkLogo}
                cover={response?.wsAccessLinkCover}
                showLegend={anyFieldRequired}
              />
            </AccessLinkPageBlock>
          )}
          <AccessLinkPageBlock>
            {response?.type === SOCIAL_METRICS_FORM_TYPE &&
              response?.metaFields?.length === 0 && (
                <div className="access-link-page__header-content__description">
                  <IDHFormattedMessage
                    id="ws_social_metrics_form_all_metrics_collected"
                    defaultMessage="All metrics are automatically collected by the system. No action required."
                  />
                </div>
              )}
            {response?.metaFields && (
              <AccessLinkPageForm
                metafields={response?.metaFields}
                wsWorkspaceUuid={response?.wsWorkspaceUuid}
                extensionUuid={response?.extensionUuid}
                setPageHandler={setPageHandler}
                type={type}
                integersOnly={response?.type === SOCIAL_METRICS_FORM_TYPE}
                contentGuidelines={response?.contentGuidelines}
              />
            )}
          </AccessLinkPageBlock>
        </>
      ) : (
        <AccessLinkPageBlock>
          <div className="access-link-page__spinner">
            <img src={spinnySpinner} width={48} alt="Loading..." />
          </div>
        </AccessLinkPageBlock>
      )}
    </div>
  );
}
